import { IDeleteProjetoDisciplinaUseCase } from "../../../presentation/useCases/delete/delete_projeto_disciplina_use_case";
import { DeleteProjetoDisciplinaRequestModel, DeleteProjetoDisciplinaResponseModel } from "../../models/disciplina_models";
import { IProjetosRepository } from "../../repositories/projetos_repository";

/**
 * DeleteProjetoDisciplinaUseCase
 */

export class DeleteProjetoDisciplinaUseCase implements IDeleteProjetoDisciplinaUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteProjetoDisciplina(model: DeleteProjetoDisciplinaRequestModel): Promise<DeleteProjetoDisciplinaResponseModel> {
    return await this.repository.deleteProjetoDisciplina(model);
  }
}
